module.exports = __webpack_public_path__ + "static/onboarding_layoutLogin-2e0eb09751033afa2c27fa915e949a5b.png";